<template>
  <td>
    <img
      :src="$webDomain + '/' + c.mainImageType + '/' + c.mainImage"
      alt="not found"
    />
  </td>
  <td>{{ c.titleEn }}</td>
  <td>{{ c.titleCh }}</td>
  <td>{{ c.descriptionEn }}</td>
  <td>{{ c.descriptionCh }}</td>
  <td>
    <BootstrapIcon
      class="listTableIcon"
      icon="pencil-square"
      @click="showEdit()"
    />
    <BootstrapIcon
      class="listTableIcon delete"
      icon="trash"
      @click="deleteItem(c._id)"
    />
  </td>
  <ModalCaseEdit
    :c="c"
    v-if="displayEdit"
    @close-modal-case="hideEdit"
  ></ModalCaseEdit>
</template>
<script>
import axios from "axios";
import authHeader from "../../services/authHeader";
import ModalCaseEdit from "./ModalCaseEdit.vue";

export default {
  name: "AdminCaseTable",
  props: {
    c: Object,
  },
  components: {
    ModalCaseEdit,
  },
  data() {
    return {
      displayEdit: false,
    };
  },
  methods: {
    deleteItem(id) {
      axios
        .delete(this.$webDomain + "/garden/GardenCase", {
          headers: authHeader(),
          data: {
            itemId: id,
          },
        })
        .then(function(response) {
          console.log(response);
          window.location.reload();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    showEdit() {
      this.displayEdit = true;
    },
    hideEdit() {
      this.displayEdit = false;
    },
  },
};
</script>
<style scoped>
img {
  max-width: 200px;
}
</style>
